import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { INDUSTRIES } from "../lib/industriesData";

export const IndustriesStrip = () => (
    <section
        data-testid="industries-strip"
        className="relative py-24 sm:py-32 bg-[#080808] border-t border-white/5"
    >
        <div className="max-w-7xl mx-auto px-6 md:px-12">
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.4 }}
                transition={{ duration: 0.6 }}
                className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12"
            >
                <div>
                    <div className="font-inter text-xs uppercase tracking-[0.25em] text-gold mb-4">
                        Industries We Serve
                    </div>
                    <h2 className="font-poppins font-semibold tracking-tight text-white text-3xl sm:text-4xl lg:text-5xl max-w-2xl">
                        Built for the businesses around you.
                    </h2>
                </div>
                <Link
                    to="/industries"
                    data-testid="industries-strip-view-all"
                    className="self-start md:self-end inline-flex items-center gap-2 font-inter text-sm text-zinc-300 hover:text-gold transition-colors"
                >
                    See how we help each industry
                    <ArrowUpRight size={16} />
                </Link>
            </motion.div>

            <div className="flex flex-wrap gap-3">
                {INDUSTRIES.map((ind, i) => (
                    <motion.div
                        key={ind.id}
                        initial={{ opacity: 0, y: 12 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, amount: 0.2 }}
                        transition={{ duration: 0.4, delay: i * 0.04 }}
                    >
                        <Link
                            to="/industries"
                            data-testid={`industry-chip-${ind.id}`}
                            className="inline-flex items-center gap-2 font-inter text-sm md:text-base text-zinc-300 border border-white/10 hover:border-gold/50 hover:text-gold rounded-full px-5 py-2.5 transition-colors"
                        >
                            {ind.name}
                        </Link>
                    </motion.div>
                ))}
            </div>
        </div>
    </section>
);

export default IndustriesStrip;
